
















import { mixins } from 'vue-class-component'
import { Component, Prop, Watch } from 'vue-property-decorator'
import AppTextSearch from '@/components/AppTextSearch.vue'
import AppTextField from '@/components/AppTextField.vue'
import SearchProducer from '@/mixins/search-queries/search-producer'
import SearchBook from '@/mixins/search-queries/search-book'
import SearchUser from '@/mixins/search-queries/search-user'
import { Producer } from '@/modules/Producer/interfaces/producer'
import { IContactSourceInput } from '@/modules/Contact/interfaces/contact-form'

@Component({
  components: {
    AppTextSearch,
    AppTextField
  }
})
export default class ContactFormSource extends mixins(SearchProducer, SearchBook, SearchUser) {
  @Prop({ type: Object as () => IContactSourceInput }) value!: IContactSourceInput
  @Prop({ type: Object as () => Producer }) readonly source!: Producer

  get sourceDisable () {
    return !!this.source
  }

  validate () {
    return (this.$refs.form as Vue & { validate: () => boolean }).validate()
  }
}
